<template>
    <div class="step step-2 flex flex-col items-center w-full top-0 bottom-0">
        <h2 class="subtitle white text-center mt-5">
            {{ $trans.get("deposits.step-2-subtitle") }}
        </h2>

        <div class="flex flex-col items-start">
            <div
                v-for="(option, idx) in options"
                class="input inline-flex cursor-pointer"
                :class="{ selected: getFormData.purpose === option }"
                :key="idx"
                @click="setPurpose(option)"
            >
                <span class="circle mr-3 flex justify-center items-center">
                    <div class="inner"></div>
                </span>
                <span class="font-bold">{{
                    $trans.get("deposits.step-2-options." + option)
                }}</span>
            </div>
        </div>

        <button
            class="mdc-button mdc-button--unelevated mdc-ripple-upgraded unelevated flex justify-between items-center mt-5"
            :disabled="!purpose"
            @click="$emit('update:current-step', 3)"
        >
            <span class="mdc-button__label -mr-1 ml-6">{{
                $trans.get("deposits.next")
            }}</span>
            <span class="material-icons">keyboard_arrow_right</span>
        </button>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    data() {
        return {
            options: ["title", "taxes", "title+taxes"]
        };
    },

    computed: {
        ...mapGetters(["getFormData"]),
        purpose() {
            return this.getFormData.purpose;
        }
    },

    methods: {
        setPurpose(value) {
            this.$store.commit("setParamFromFormData", {
                param: "purpose",
                value
            });
        }
    },

    watch: {
        purpose(purpose) {
            let param;
            if (purpose === "title") {
                param = 'taxesAmount';
            }
            if (purpose === 'taxes') {
                param = 'titleAmount';
            }
            if (param) {
                this.$store.commit("setParamFromFormData", {
                    param,
                    value: null,
                });
            }
        }
    }
};
</script>
